import styled from "styled-components";

import { InlineButton as StyledInlineButton } from "components/atoms/Button";
import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
export const ModelContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
`;

export const ModelCard = styled.div`
    border: 1px solid ${colourScheme.primaryLight};
    background-color: ${colourScheme.primary};
    border-radius: 0.5rem;
    padding: 1rem;
    width: 47%;
    cursor: pointer;
    text-align: center;
    box-shadow: 0 0.625rem 1.25rem rgba(0, 0, 0, 0.5);
    transition: transform 0.2s ease-in-out;
    &:hover {
        transform: scale(1.05);
    }
    ${device.md} {
        width: 30%;
    }

    ${device.lg} {
        width: 23%;
    }
`;

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    max-width: 100vw;
    width: 100%;
    padding: 1rem;
    max-height: 90vh;
    overflow-y: auto;

    ${device.lg} {
        max-width: 70vw;
    }

    ${device.xl} {
        max-width: 60vw;
    }
`;

export const DefaultModelContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0.5rem;

    flex-grow: 2;
    gap: 1rem;
    min-width: 7rem;
    border: 1px solid ${colourScheme.primaryLight};
    border-radius: 0.5rem;
    cursor: pointer;
    background-color: ${colourScheme.primary};

    &:hover {
        background-color: ${colourScheme.primaryLight};
    }

    span {
        margin-left: 0.5rem;
        font-weight: bold;
    }

    img {
        border-radius: 0.5rem;
    }

    ${device.md} {
        min-width: 10rem;
    }
`;

export const InlineButton = styled(StyledInlineButton)`
    margin-left: auto;
    opacity: 0.5;
    cursor: pointer;
`;

export const LabelWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const ModelName = styled.div`
    margin-top: 0.5rem;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    flex-wrap: wrap;

    ${device.xl} {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const SubscriberOnlyBadge = styled.div`
    background: linear-gradient(
        90deg,
        ${colourScheme.alertLight} 0%,
        ${colourScheme.alertDark} 100%
    );
    color: ${colourScheme.primary};
    padding: 0.25rem 0.5rem;
    border-radius: 1rem;
    font-size: 0.75rem;
    font-weight: bold;
    margin-top: 0.5rem;

    ${device.md} {
        margin-left: 0.5rem;
        margin-top: 0.5rem;
    }

    ${device.xl} {
        white-space: nowrap;
    }
`;

export const NewBadge = styled.div`
    background: linear-gradient(
        90deg,
        ${colourScheme.successLight} 0%,
        ${colourScheme.successDark} 100%
    );
    color: ${colourScheme.primary};
    padding: 0.25rem 0.5rem;
    border-radius: 1rem;
    font-size: 0.75rem;
    font-weight: bold;
    margin-top: 0.5rem;

    ${device.md} {
        margin-left: 0.5rem;
        margin-top: 0.5rem;
    }

    ${device.xl} {
        white-space: nowrap;
    }
`;
